module.exports = __webpack_public_path__ + "img/product_banner_01.bc784cf6.jpg";